import { Button, Card, Row, message } from "antd";
import { useState } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";
const FilebrowserDeploy = ({ appName, app, getData, lastDeployDatetime }) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const doDeploy = () => {
        setLoading(true);
        HTTPClient.post("/appcustomizations/filebrowser/deploy", { appName, entryfile: "main.py" }) // TODO: entryfile
            .then((res) => {
                message.success(t("dettaglio_app.file_browser_deploy.success"));
                setLoading(false);
            })
            .catch((e) => {
                message.error(t("dettaglio_app.file_browser_deploy.success"));
                setLoading(false);
            });
    };

    return (
        <Card title="Deploy" style={{ width: "100%", marginTop: "15px" }}>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                {t("dettaglio_app.file_browser_deploy.info")}
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Button type="primary" onClick={doDeploy} loading={loading}>
                    {t("dettaglio_app.file_browser_deploy.call_to_action")}
                </Button>
            </Row>
            {lastDeployDatetime && (
                <Row style={{ width: "100%", marginTop: "10px" }}>
                    {t("dettaglio_app.file_browser_deploy.last_deploy_datetime")}: {new Date(lastDeployDatetime).toLocaleString()} (UTC)
                </Row>
            )}
        </Card>
    );
};

export { FilebrowserDeploy };
